<template>
	<el-card shadow="never" class="aui-card--fill">
		<el-row style="background-color: #F3F4F4;">
			<el-col :xs="24" :md="6" style="line-height: 40px;font-size: 16px;color: #121212;font-weight: bold;">
				<img style="width: 16px;height: 16px;margin-right: 12px;" src="../../../assets/img/user-list.png" />
				{{!dataForm.id ? '发布新任务' : '修改任务信息'}}
			</el-col>
			<el-col :xs="24" :md="18">
				<el-form :inline="true" style="text-align: right;">
					<el-form-item v-if="dataForm.status != 2"><el-button type="primary" @click="dataFormSubmitHandle('1')">任务发布</el-button></el-form-item>
					<el-form-item><el-button v-no-more-click v-if="$hasPermission('plat:plattask:save')" class="refreshBtn" style="left: 500px;" type="primary" :loading="loadingbut" @click="dataFormSubmitHandle('0')">保存</el-button></el-form-item>
					<!-- <el-form-item><el-button class="refreshBtn" style="left: 500px;" type="info" @click="$router.go(0);">刷新</el-button></el-form-item> -->
					<el-form-item v-if="dataForm.id"><el-button class="refreshBtn" style="left: 500px;" type="info" @click="$router.go(-1)">返回列表</el-button></el-form-item>
				</el-form>
			</el-col>
		</el-row>
		<div style="padding: 50px;">
			<el-form :model="dataForm" :rules="dataRule" ref="dataForm" :label-width="$i18n.locale === 'en-US' ? '120px' : '150px'">
				<!-- <el-form-item label="任务发布编号" prop="taskCode">
		    <el-input v-model="dataForm.taskCode" placeholder="自动生成" :disabled="true" style="border: none"></el-input>
		  </el-form-item> -->
      <el-form-item label="税源地" prop="bodyId">
        <el-select v-model="dataForm.bodyId" placeholder="请选择" style="width:100%" clearable filterable @change="sydChange">
          <el-option
            v-for="item in caSydList"
            :key="item.id"
            :label="`${item.bodyName}-${item.abbreviation}`"
            :value="item.bodyId">
          </el-option>
        </el-select>
      </el-form-item>  
      <el-row>
					<el-form-item label="任务名称" class="itemLabel"  prop="names">
						<div class="itemInpWap"   v-for="item,index in dataForm.names" :key="item.key">
							<el-form-item   :prop="'names.' + index + '.name'"
											:rules="{
							    				required: true, message: '必填项不能为空', trigger: 'blur'
											}">
								<el-input  class="itemInp"
										   style="width: 200px;float:left; margin-top: 8px"
										   v-model="item.name"
										   placeholder="请输入任务名称" >
								</el-input>
								<div class="itemBtn" style="float: left;margin-top: 8px;width: 90px">
									<el-button style="margin-left: 10px" @click="handleAdd()" class="el-icon-plus btn-plus" ></el-button>
									<el-button style="margin-right: 10px" v-if="index>0" @click="deleteItem(item,index)" class="el-icon-minus btn-plus" ></el-button>
								</div>
							</el-form-item>

						</div>
					</el-form-item>
				</el-row>
				<el-row>
					<el-col :md="12" :lg="12">
						<el-form-item label="任务大类" prop="taskType" v-if="role == 'COMPANY'">
              <el-select style="width: 100%;" filterable v-model="dataForm.taskType" placeholder="任务大类">
								<el-option v-for="item in taskTypes" :key="item.ticketProject" :label="item.ticketProject" :value="item.ticketProId"></el-option>
							</el-select>
            </el-form-item>
            <el-form-item label="任务大类" prop="taskType" v-else>
              <ren-select v-model="dataForm.taskType" dict-type="taskType" style="width:100%" :isDisabled="dataForm.status == 2"></ren-select>
            </el-form-item>
					</el-col>
          <el-col :md="12" :lg="12">
            <el-form-item label="关联合同编号" prop="contractCode">
							<el-select style="width: 100%;" filterable v-model="dataForm.contractCode" placeholder="合同编号">
								<el-option v-for="item in options" :key="item.contractCode" :label="item.contractCode" :value="item.contractCode"></el-option>
							</el-select>
						</el-form-item>
          </el-col>
				</el-row>
				
        <el-row>
          <el-col :md="12" :lg="12">
            <el-form-item label="任务简述" prop="taskDesc">
              <el-input type="textarea" rows="4" style="width: 100%;" v-model="dataForm.taskDesc" placeholder="请描述您的任务具体做什么事情" show-word-limit></el-input>
            </el-form-item> 
          </el-col>
          <el-col :md="12" :lg="12">
            <el-form-item label="业务月体量" prop="monthlyVolume">
              <el-input type="textarea" rows="4" style="width: 100%;" v-model="dataForm.monthlyVolume" placeholder="请输入" show-word-limit></el-input>
            </el-form-item> 
          </el-col>
          <el-col :md="12" :lg="12">
            <el-form-item label="业务场景说明" prop="businessScenario">
              <el-input type="textarea" rows="4" style="width: 100%;" v-model="dataForm.businessScenario" placeholder="请描述您为什么需要用到灵工" show-word-limit></el-input>
            </el-form-item>
          </el-col>
        </el-row>
				<el-row>
          <el-col :md="12" :lg="12">
            <el-form-item label="结算价格及结算方式" prop="taskRequire">
              <el-input type="textarea" rows="4" style="width: 100%;" v-model="dataForm.taskRequire" placeholder="请按照格式要求说明。结算价：xx元——xx元/小时结算 ；结算方式：验收合格后，通过灵工平台进行结算 " show-word-limit></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="12" :lg="12">
            <el-form-item label="任务计价" prop="pricingMethod">
              <el-input type="textarea" rows="4" style="width: 100%;" v-model="dataForm.pricingMethod" placeholder="请描述您的任务是以天、或者是什么单位进行结算计价以及计价方法" show-word-limit></el-input>
            </el-form-item>
          </el-col>
        </el-row>
				
				<el-row>
					<!-- <el-col :md="24" :lg="6">
						<el-form-item label="需求人数" prop="requirePerson">
							<el-input style="width: 95%;" v-model="dataForm.requirePerson" placeholder="需求人数" type="number" min="1"></el-input>
						</el-form-item>
					</el-col>
					<el-col :md="24" :lg="6">
						<el-form-item label="预算金额" prop="budget">
							<el-input style="width: 95%;" v-model="dataForm.budget" placeholder="预算金额" type="number" maxlength="10"><i slot="suffix" style="font-style:normal;margin-right: 10px;">元</i></el-input>

						</el-form-item>
					</el-col> -->
				</el-row>
				<el-row>
					<!-- <el-col :md="24" :lg="10">
				<el-form-item label="任务周期" prop="startDate">
					<el-date-picker
						v-model="dataForm.startDate"
						start-placeholder="开始日期"
						align="right"
						type="date"
						format="yyyy-MM-dd"
						value-format="yyyy-MM-dd"
						 style="width:48%"
					></el-date-picker>
					<span style="width:4%;text-align: center;display: inline-block;">~</span>
					<el-date-picker
						v-model="dataForm.endDate"
						end-placeholder="结束日期"
						align="right"
						type="date"
						format="yyyy-MM-dd"
						value-format="yyyy-MM-dd"
						 style="width:48%"
					></el-date-picker>
				</el-form-item>
				</el-col> -->
				<el-col :md="24" :lg="24">
				<el-form-item prop="optionCheck">
					<el-checkbox-group v-model="dataForm.optionCheck" style="display: inline-block;">
						<el-checkbox label="协议" name="type">
							我已阅读并同意

						</el-checkbox>
					</el-checkbox-group>
					<font color="#2C4BD5" style="cursor: pointer;" @click.stop="dialogVisible = true">财天下共享经济服务平台《信息发布承诺书》</font>
				</el-form-item>
				</el-col>
				</el-row>
				<el-form-item>


				</el-form-item>
			</el-form>

		</div>
		<el-dialog :show-close="false" top="6vh" width="1056px" title="信息发布承诺书" :visible="dialogVisible">
			<div style="font-size: 12px;color: #333;line-height: 34px;text-indent: 24px;text-align: left;height: 640px;overflow-y: scroll;">
				<p>在此特别提醒您（企业用户）在平台内发布外包任务前，请认真阅读本《信息发布承诺书》（以下简称“承诺书”），确保您充分理解本承诺书中所述事项。请您审慎阅读并选择同意接受或不接受本承诺书。</p>
				<p>本承诺书约定企业用户在平台内发布任务的过程中，将严格遵守国家相关法律、法规，保证本公司提供的信息内容真实、有效、合法、合规，并切实做到：</p>
				<p>
					一、本单位承诺遵守《中华人民共和国计算机信息系统安全保护条例》及有关法律、法规和行政规章制度、文件规定；<br />
					<span style="display: inline-block;width: 24px;"></span>
					二、本单位保证不利用网络危害国家安全、泄露国家秘密，不侵犯国家的、社会的、集体的利益和第三方合法权益，不从事违法犯罪活动；<br />
					<span style="display: inline-block;width: 24px;"></span>
					三、本单位保证所发布的任务信息内容真实、有效、合法，不存在虚假记载、误导性陈述；<br />
					<span style="display: inline-block;width: 24px;"></span>
					四、本单位承诺不通过互联网制作、复制、查阅和传播下列信息：<br />
					<span style="display: inline-block;width: 48px;"></span>
					1.反对宪法所确定的基本原则的；<br />
					<span style="display: inline-block;width: 48px;"></span>
					2.危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；<br />
					<span style="display: inline-block;width: 48px;"></span>
					3.损害国家荣誉和利益的；<br />
					<span style="display: inline-block;width: 48px;"></span>
					4.煽动民族仇恨、民族歧视，破坏民族团结的；<br />
					<span style="display: inline-block;width: 48px;"></span>
					5.破坏国家宗教政策，宣扬邪教和封建迷信的；<br />
					<span style="display: inline-block;width: 48px;"></span>
					6.散布谣言，扰乱社会秩序，破坏社会稳定的；<br />
					<span style="display: inline-block;width: 48px;"></span>
					7.散步淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；<br />
					<span style="display: inline-block;width: 48px;"></span>
					8.侮辱或者诽谤他人，侵害他人合法权益的；<br />
					<span style="display: inline-block;width: 48px;"></span>
					9.含有法律法规禁止的其他内容的。<br />
					<span style="display: inline-block;width: 24px;"></span>
					五、对客户的个人信息保密，未经客户同意不得向他人泄露，但法律规定的除外。<br />
					<span style="display: inline-block;width: 24px;"></span>
					如果违反上述承诺，财天下共享经济服务平台有权封闭该企业用户账号并停止相关服务，并由该企业用户承担赔偿损失、消除影响等违约责任。
					</p>
			</div>
			<div slot="footer" class="dialog-footer">
			  <el-button style="color: #409eff;" type="text" @click="nodoread">不同意</el-button>
			  <el-button style="background-color: #409eff;border: none;" type="primary" @click="doRead">我同意</el-button>
			</div>
		</el-dialog>
	</el-card>
</template>

<script>
import ArrayUtils from "../../../utils/ArrayUtils";
import debounce from 'lodash/debounce'
import { addDynamicRoute } from '@/router'
import { isNumber } from '@/utils/validate'
import Cookies from 'js-cookie'

export default {
  data () {
    return {
      caSydList:[],
      role:Cookies.get('admin_role'),
      taskTypes:[],
      visible: false,
	  loadingbut: false,
      dataForm: {
        monthlyVolume:'',
        bodyId:'',
        pricingMethod:'',
        id: '',
        taskDesc: '',
        businessScenario:'',
        taskRequire: '',
        requirePerson: '',
        budget: '',
        contractCode: '',
        startDate: '',
        endDate: '',
        status: '',
        creator: '',
        createDate: '',
        updater: '',
        updateDate: '',
        taskCode: '',
        taskType: '',
        taskStatus: '',
        contractId: '',
        optionCheck: [],
		names:[{name:''}]
      },
      options: [],
      dialogVisible: false
    }
  },
  computed: {
    dataRule () {
      let that = this;
      var checkNum = (rule, value, callback) => {
		                if (!isNumber(value)) {
		                    callback(new Error('请输入数字值'))
		                }
        callback()
      }
      var checkNumtwo = (rule, value, callback) => {
        if (/^(?!0+(?:\.0+)?$)(?:[1-9]\d*|0)(?:\.\d{1,2})?$/.test(value)) {
          callback()
        } else {
          callback(new Error('请输入大于0的数字值,并且最多两位小数'))
        }
      }
      var checkStartDate = (rule, value, callback) => {
        if (!value || !that.dataForm.endDate) {
          callback(new Error('日期不能为空！'));
        } else {
            // 结束日期有，进行判断
          if (that.compareDate(value, that.dataForm.endDate)) {
            // 如果起始在结束之前
            callback()
          } else {
            callback(new Error('起始日期不能在结束日期之后，请重新选择'))
          }
          
        }
      }
      return {
        bodyId: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ],
        taskDesc: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        businessScenario: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        taskType: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        taskRequire: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        pricingMethod: [
        { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        requirePerson: [
          { required: true, message: '请填写整数', validator: checkNum, trigger: 'blur' }
        ],
        budget: [
          { required: true, message: '请输入大于0的数字值,并且最多两位小数', validator: checkNumtwo, trigger: 'blur' }
        ],
        contractCode: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        startDate: [
          { required: true,validator:checkStartDate, trigger: 'blur' }
        ],
          names:[
              { required: true, message: '必填项不能为空',  trigger: 'blur' }
          ],
		  name:[
		      { required: true, message: '必填项不能为空',  trigger: 'blur' }
		      ],
        optionCheck: [{
          type: 'array',
          required: true,
          message: '请勾选我已详细阅读并同意',
          trigger: 'change'
        }]
      }
    }
  },
  created () {
    this.dataForm.id = this.$route.params.id || ''
    this.init()
  },
  methods: {
    sydChange(e){
      console.log(e)
      this.serviceFeeType =  ArrayUtils.getItemBy(this.caSydList,"bodyId",e).serviceFeeType
      this.serviceFeeType1 =  ArrayUtils.getItemBy(this.caSydList,"bodyId",e).serviceFeeType

      this.dataForm.bodyName = ArrayUtils.getItemBy(this.caSydList,"bodyId",e).bodyName
      this.dataForm.abbreviation = ArrayUtils.getItemBy(this.caSydList,"bodyId",e).abbreviation
      this.dataForm.taskType = ''
      this.$set(this,'taskTypes',ArrayUtils.getItemBy(this.caSydList,"bodyId",e).taskTypes)
      this.getContract(e)

    },
//      任务名称增加
      handleAdd(){
          let ind = this.dataForm.names.length
          if(ind == 6 ){
			return;
		  }else{
              this.dataForm.names.push({
                  name: '',
              })
		  }
	  },
      deleteItem (item, index) {
          if(index == 0){
              return ;
		  } else{
              this.dataForm.names.splice(index, 1)
		  }
      },
 //字符串转化成数式
      setNamesFn(str){
          str = str.split(',')
          let getNames = [];
          for (var i=0;i<str.length;i++){
              getNames.push({name : str[i]})
          }
          return getNames
      },
    getContract (bodyId) {
      this.dataForm.contractCode = '';
      this.$http.get(`/sys/plat/contract/getContractCodeList?bodyId=${bodyId}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.options = res.data
      }).catch(() => {})
    },
    async init () {
      // 获取当前企业税源地列表
      const res1 = await this.$http.get(`/sys/plat/body/getCaBodyList?userId=${Cookies.get("userInfoId")}`,{});
      this.caSydList = res1.data.data
      console.log(this.caSydList)
      
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if(this.caSydList && this.caSydList.length == 1){
          this.$set(this.dataForm,'bodyId',this.caSydList[0].bodyId)
          this.$set(this.dataForm,'bodyName',this.caSydList[0].bodyName)
          this.$set(this.dataForm,'abbreviation',this.caSydList[0].abbreviation)
          this.dataForm.taskType = ''
          this.$set(this,'taskTypes',this.caSydList[0].taskTypes)
          this.getContract(this.caSydList[0].bodyId)
        }
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
      // if(this.role == 'COMPANY'){
      //   this.$http.get('/sys/user/info').then(({ data: res }) => {
      //     this.taskTypes = res.data.taskTypes
      //   })
      // }
      
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/plat/task/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
          res.data.names = this.setNamesFn( res.data.names)
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
//	  去除数组中的属性值
      setNames(arr){
          let  formNams = [];
          for (var i=0;i<arr.length;i++){
              formNams.push(arr[i].name)
		  }
		  return formNams
	  },

    // 表单提交
    dataFormSubmitHandle: debounce(function (inStatus) {
        console.log(this.dataForm)
        this.dataForm.taskStatus = inStatus
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.loadingbut = true
        for (let i = 0; i < this.options.length; i++) {
          if (this.options[i].contractCode == this.dataForm.contractCode) {
            this.dataForm.contractId = this.options[i].id
          }
        }
          let params = {...this.dataForm};
          params.names = this.setNames(params.names).join(',');
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/plat/task/', params).then(({ data: res }) => {
          this.loadingbut = false
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }else{
            if(inStatus == 0){
              this.$message.success('任务保存成功！')
            }else{
              this.$message.success('任务发布成功！')
            }
            // this.$router.go(0);
            setTimeout(() =>  {
            // this.$router.go(0);
            if(this.dataForm.id){
              this.$router.go(-1)
            }else{
              // this.getContract()
              // this.init()
              this.$router.push({name:'plat-plattask'})
            }
             
            },1000)
          }
          
          // this.$message({
          //   message: this.$t('prompt.success'),
          //   type: 'success',
          //   duration: 500,
          //   onClose: () => {
          //     if (this.dataForm.id == '') {
          //       this.dataForm.id = res.data
          //     }

          //     if (this.dataForm.taskStatus == 1) {
          //       const routeParams = {
          //         routeName: `${this.$route.name}__任务详情`,
          //         title: `任务详情`,
          //         path: 'plat/platttask-info',
          //         params: {
          //           id: this.dataForm.id,
          //           num: -2
          //         }
          //       }
          //       // 动态路由
          //       addDynamicRoute(routeParams, this.$router)
          //     }
          //   }
          // })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false }),

    doRead () {
      this.dataForm.optionCheck[0] ? this.dataForm.optionCheck[0] = '协议' : this.dataForm.optionCheck.push('协议')
      this.dialogVisible = false
    },
    nodoread () {
      this.dataForm.optionCheck = []
      this.dialogVisible = false
    },
    compareDate (start, end) {
      return new Date(end).getTime() > new Date(start).getTime()
    }

  }
}
</script>
<style type="scss" scoped>
		.btn-plus{
			width: 30px;
			height:30px;
			padding: 0;
			border-radius: 50%;
		}
		.itemInpWap{
			float: left;
			.itemInp{
				margin-top: 10px !important;
			}
			.itemBtn{
				float: left;
			}
		}
		/deep/ .itemLabel .el-form-item__label{
			margin-top: 16px;
		}
		/*:first-child .itemInpWap {*/
			/*.el-icon-plus{*/
				/*margin-right: 10px;*/
			/*}*/
		/*}*/

</style>
